// extracted by mini-css-extract-plugin
module.exports = {"checked":"IconCheckbox_checked__1tjcC","box":"IconCheckbox_box__2iRuL","isChecked":"IconCheckbox_isChecked__143o0"};